const USER_STORAGE = '@ravim:user';
const AUTH_TOKEN_STORAGE = '@ravim:TOKEN';
const MENU_COLLAPSE = '@ravim:collapse'

export { USER_STORAGE, AUTH_TOKEN_STORAGE, MENU_COLLAPSE };
